/**
 * The reservation the workspace renders around.
 *
 * The live values arrive from the DMS through the tenant's secure link. The
 * screens read them via useReservation() in reservationContext.tsx; RESERVATION
 * below is the fallback for a visit with no ?id=, so the design stays
 * reviewable without a real reservation behind it.
 *
 * The phone steps keep their own copy in TenantWelcomePage. They are dormant
 * while the desktop workspace is the single wired surface.
 */
export interface Reservation {
  channel: string;
  channelLogo: string;
  photo: string;
  /** Full name for the stay summary. */
  tenantName: string;
  /** Used on its own in the rail's greeting. */
  tenantFirstName: string;
  property: string;
  /** Small caps overlay on the photo. */
  propertyBadge: string;
  /** "PARIS · LE MARAIS" — city and neighbourhood, above the property name. */
  district: string;
  address: string;
  bookingReference: string;
  /** Plain calendar dates; formatted per locale at render. */
  checkIn: string;
  checkOut: string;
  /** How many photos the Europea team took at the post-cleaning inspection. */
  inspectionPhotoCount: number;
  /** Cap on the tenant's own inventory photos. */
  maxTenantPhotos: number;
  /** The insurance certificate is due this many days after moving in. */
  insuranceDueDays: number;
}

export const RESERVATION: Reservation = {
  channel: "Blueground",
  channelLogo: "/logo/Blueground-Logo.png",
  photo: "/living-area.jpg",
  tenantName: "Antonella Brosco",
  tenantFirstName: "Antonella",
  property: "Le Marais Elegant",
  propertyBadge: "Le Marais Élégant",
  district: "Paris · Le Marais",
  // address: "17 Rue des Francs Bourgeois, 75004 Paris",
  address: "29B Rue des Francs-Bourgeois, 75004 Paris",
  bookingReference: "ER-260903-184",
  checkIn: "2026-09-03",
  checkOut: "2026-12-03",
  inspectionPhotoCount: 20,
  // Both come from the specification and are sent by the API; kept in step here
  // so the no-reservation preview does not quote different limits.
  maxTenantPhotos: 10,
  insuranceDueDays: 7,
};
